<template>
  <div class="userInfo app-container">
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">
        <div class="global-table-header">
          <div class="orgDetails-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchEvn" />
          </div>
          <div class="orgDetails-btn">
            <!-- <button class="global-button-style" @click="batchDel">{{$t('commonMsg.del')}}</button> -->
            <button
              class="global-button-style"
              @click="$store.commit('windowHandle', 'addPopup')"
            >
              {{ $t("org.newDevice") }}
            </button>
            <!-- <button class="global-button-style">{{$t('org.exportUsers')}}</button> -->
            <!-- <button class="global-button-style">导入设备</button> -->
            <el-upload
              style="display:inline-block"
              :action="`/api/1/orgs/bindDeviceBatch/${$route.query.id}`"
              :on-success="uploadSuccess"
              :show-file-list="false"
              :headers="myHeaders"
            >
              <button class="global-button-style">
                {{ $t("org.importDevice") }}
              </button>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="global-body-wrap">
        <appTable
          ref="table"
          :tableData="tableData"
          :tableProps="tableProps"
          :selectCtrl="false"
          @tableSelection="tableSelection"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
    <transition name="fade">
      <addComponent
        v-if="addPopup"
        :title="$t('org.newDevice')"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @addEvn="addEvn"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import addComponent from "@/components/addPopup";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    appTable,
    pagination,
    addComponent
  },
  computed: {
    ...mapGetters(["addPopup"]),
    tableProps() {
      let tableProps = [
        {
          prop: "model",
          label: this.$t("user.model")
        },
        {
          prop: "macAddress",
          label: this.$t("org.macAddress")
        },
        {
          prop: "updated_at",
          label: this.$t("org.updated_at")
          // width: 150
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          btn: [this.$t("commonMsg.del")]
        }
      ];
      return tableProps;
    },
    rules() {
      let rules = {
        mac: [{ required: true, message: "请输入MAC地址", trigger: "blur" }],
        deviceUniqueId: [
          { required: true, message: "请输入deviceUniqueId", trigger: "blur" }
        ],
        model: [{ required: true, message: "请输入型号", trigger: "blur" }]
      };
      return rules;
    },
    ruleProps() {
      let ruleProps = [
        {
          prop: "mac",
          label: "MAC"
          // placeholder: this.$t('alertMsg.userRole')
        },
        {
          prop: "deviceUniqueId",
          label: "设备UniqueId"
          // placeholder: this.$t('alertMsg.userRole')
        },
        {
          prop: "model",
          label: this.$t("user.model")
        }
      ];
      return ruleProps;
    }
  },
  mixins: [listMixin],
  data() {
    return {
      params: {
        limit: 20,
        offset: 0
      },
      hasBatch: false,
      devIds: [],
      tableData: [],
      total: 0,
      ruleForm: {
        mac: "",
        deviceUniqueId: "",
        model: ""
      },
      myHeaders: {
        Authorization: `Bearer ${this.$cookie.get("token")}`
      }
    };
  },
  methods: {
    getList() {
      this.$http.getOrgDevices(this.$route.query.id, this.params).then(res => {
        this.total = res.data.count;
        this.tableData = res.data.rows;
      });
    },
    unBindDevice(ids) {
      this.$http.unBindDevice({ id: this.$route.query.id, ids }).then(res => {
        this.hasBatch = false;
        this.getList();
        this.elMsg(this.$t("alertMsg.delSuccess"), "success");
      });
    },
    addEvn(obj) {
      this.$http.bindDevice(this.$route.query.id, obj).then(res => {
        this.getList();
        this.$store.commit("windowHandle");
      });
    },
    batchDel() {
      this.hasBatch = true;
      this.$store.commit("windowHandle", "delPopup");
    },
    del(obj) {
      let ids = !this.hasBatch ? [obj.row.id] : this.devIds;
      this.unBindDevice(ids);
    },
    tableSelection(arr) {
      this.devIds = arr;
    },
    uploadSuccess(file) {
      this.getList();

      this.elMsg("导入成功", "success");
    }
  },
  mounted() {
    // this.getList()
  }
};
</script>

<style lang="scss" scoped>
.userInfo {
}
</style>
